import { toastr } from 'react-redux-toastr';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { store } from '~/store';
import { ResponseProps } from '../../../utils/helper';
import {
  changeStateAssuntosRequest,
  changeStateAssuntosSuccess,
  getAssuntosFailure,
  getAssuntosHandleChangePageFailure,
  getAssuntosHandleChangePageRequest,
  getAssuntosRequest,
  getAssuntosSuccess,
  postAssuntosRequest,
  updateAssuntosFailure,
  updateAssuntosRequest,
  updateAssuntosSuccess,
} from './actions';
import { CriacaoAssuntoTypes } from './types';

function* getAssuntos({ payload }: ReturnType<typeof getAssuntosRequest>) {
  const { token, company } = yield select(state => state.auth);

  try {
    const response: ResponseProps = yield call(
      api.get,
      '/v1/assuntos?pageNo=0&pageSize=5',
      {
        headers: {
          Authorization: `Bearer ${token}`,
          company: company?.country_company_id,
        },
      },
    );

    const assuntos: any = [];

    response.data.forEach((element: any) => {
      assuntos.push({
        country_company_id: element.country_company_id,
        contact_subject_id: element.contact_subject_id,
        subject_ds: element.subject_ds,
        status_fl: element.status_fl,
        operator_id: element.operator_id,
        total_itens: element.total_itens,
      });
    });

    yield put(getAssuntosSuccess(assuntos));
  } catch (error) {
    yield put(getAssuntosFailure());
  }
}

function* getAssuntosHandleChange({
  payload,
}: ReturnType<typeof getAssuntosHandleChangePageRequest>) {
  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/assuntos?pageNo=${payload.newPage}&pageSize=${payload.rowsPerPage}`,
      {
        headers: {
          'Content-Type': 'application/json',
          company: payload.company,
        },
      },
    );

    const assuntos: any = [];

    response.data.forEach((element: any) => {
      assuntos.push({
        country_company_id: element.country_company_id,
        contact_subject_id: element.contact_subject_id,
        subject_ds: element.subject_ds,
        status_fl: element.status_fl,
        operator_id: element.operator_id,
        total_itens: element.total_itens,
      });
    });

    yield put(getAssuntosSuccess(assuntos));
  } catch (error) {
    yield put(getAssuntosHandleChangePageFailure());
  }
}

function* changeStateAssuntos({
  payload,
}: ReturnType<typeof changeStateAssuntosRequest>) {
  let { tempData } = store.getState().criacaoAssunto;

  const assuntos: any[] = [];

  const index = tempData.findIndex(
    (index: any) => index.contact_subject_id === payload.contact_subject_id,
  );

  if (tempData.length > 0 && index !== -1) {
    //@ts-ignore
    tempData.forEach((element: any) => {
      assuntos.push({
        country_company_id: element.country_company_id,
        contact_subject_id: element.contact_subject_id,
        subject_ds: element.subject_ds,
        status_fl: element.status_fl,
        operator_id: element.operator_id,
      });
    });

    assuntos[index].status_fl = payload.status_fl;
  } else {
    //@ts-ignore
    tempData.forEach((element: any) => {
      assuntos.push({
        country_company_id: element.country_company_id,
        contact_subject_id: element.contact_subject_id,
        subject_ds: element.subject_ds,
        status_fl: element.status_fl,
        operator_id: element.operator_id,
      });
    });
    assuntos.push({
      contact_subject_id: payload.contact_subject_id,
      country_company_id: payload.country_company_id,
      operator_id: payload.operator_id,
      status_fl: payload.status_fl,
      subject_ds: payload.subject_ds,
    });
  }

  yield put(changeStateAssuntosSuccess(assuntos));
}

function* updateAssuntos({
  payload,
}: ReturnType<typeof updateAssuntosRequest>) {
  const { token, company } = yield select(state => state.auth);

  let { tempData } = store.getState().criacaoAssunto;

  const data: any = [];

  tempData.forEach((element: any) => {
    data.push({
      country_company_id: element.country_company_id,
      contact_subject_id: element.contact_subject_id,
      subject_ds: element.subject_ds,
      status_fl: element.status_fl,
      operator_id: element.operator_id,
    });
  });

  try {
    yield call(api.post, '/v1/assuntos', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        company: company?.country_company_id,
      },
    });

    const toastrConfirmOptions = {
      onOk: () => {},
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm('Alteração efetuada com sucesso.', toastrConfirmOptions);

    yield put(updateAssuntosSuccess());
    yield put(getAssuntosRequest(payload.company));
  } catch (error) {
    yield put(updateAssuntosFailure());
  }
}

function* postAssuntos({ payload }: ReturnType<typeof postAssuntosRequest>) {
  try {
    const data = [
      {
        country_company_id: payload.params.country_company_id,
        subject_ds: payload.params.subject_ds,
        status_fl: 'Y',
        operator_id: 'MARCIO',
      },
    ];

    yield call(api.post, '/v1/assuntos', JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
        company: payload.params.country_company_id,
      },
    });

    const toastrConfirmOptions = {
      onOk: () => {},
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm('Inclusão efetuada com sucesso.', toastrConfirmOptions);
    yield put(updateAssuntosSuccess());
    yield put(getAssuntosRequest(payload.params.country_company_id));
  } catch (error) {
    yield put(updateAssuntosFailure());
  }
}

export default all([
  takeLatest(CriacaoAssuntoTypes.GET_ASSUNTOS_RESQUEST, getAssuntos),
  takeLatest(
    CriacaoAssuntoTypes.GET_ASSUNTOS_HANDLE_CHANGE_PAGE_RESQUEST,
    getAssuntosHandleChange,
  ),
  takeLatest(
    CriacaoAssuntoTypes.CHANGE_STATE_ASSUNTOS_RESQUEST,
    changeStateAssuntos,
  ),
  takeLatest(CriacaoAssuntoTypes.UPDATE_ASSUNTOS_RESQUEST, updateAssuntos),
  takeLatest(CriacaoAssuntoTypes.POST_ASSUNTOS_RESQUEST, postAssuntos),
]);
